import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

export interface NotificacionPrestamo {
  id: number;
  solicitanteNombre: string;
  cantidad: number;
  fecha: string;
}

interface NotificacionesContextValue {
  notificaciones: NotificacionPrestamo[];
  fetchNotificaciones: () => Promise<void>;
  descartar: (id: number) => void;
}

const NotificacionesContext = createContext<NotificacionesContextValue | undefined>(undefined);

export const NotificacionesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notificaciones, setNotificaciones] = useState<NotificacionPrestamo[]>([]);

  const fetchNotificaciones = useCallback(async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user') || '{}');
      if (!user.Id) return;
      const res = await fetch(
        'https://inventariosbackend.velasresorts.com/inventarios/salidas-temporales/notificaciones',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ usuarioId: user.Id }),
        }
      );
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data)) setNotificaciones(data);
      }
    } catch {
      /* silently ignore — keeps current state (mock or previous fetch) */
    }
  }, []);

  const descartar = useCallback((id: number) => {
    setNotificaciones(prev => prev.filter(n => n.id !== id));
  }, []);

  useEffect(() => {
    fetchNotificaciones();
    const interval = setInterval(fetchNotificaciones, 30_000);
    return () => clearInterval(interval);
  }, [fetchNotificaciones]);

  return (
    <NotificacionesContext.Provider value={{ notificaciones, fetchNotificaciones, descartar }}>
      {children}
    </NotificacionesContext.Provider>
  );
};

export const useNotificaciones = (): NotificacionesContextValue => {
  const ctx = useContext(NotificacionesContext);
  if (!ctx) throw new Error('useNotificaciones must be used within NotificacionesProvider');
  return ctx;
};
